module.exports = __webpack_public_path__ + "img/5-vidio.65358b28.jpg";